<template>
  <div :class="className" :style="{ height: height, width: width }" />
</template>

<script>
import * as echarts from "echarts";
//import resize from "./mixins/resize";
import chartResize from "./mixins/chart-resize";

export default {
  mixins: [chartResize],
  props: {
    className: {
      type: String,
      default: "chart",
    },
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    autoResize: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: "",
    },
    chartData: {
      type: Object,
      required: true,
    },
    xAxisName: {
      type: String,
      default: "",
    },
    yAxisName: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      chart: null,
    };
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.setOptions(val);
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart();
    });
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$el);
      this.setOptions(this.chartData);
    },
    setOptions(data) {
      this.chart.setOption({
        title: {
          text: this.title,
          textStyle: {
            fontSize: 16,
            color: "#c0c3cd",
          },
        },
        tooltip: {
          trigger: "axis",
          show: false,
        },
        legend: {
          show: false,
        },
        grid: {
          top: 35,
          left: "2%",
          right: "10%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            name: this.xAxisName,
            splitLine: {
              show: false,
            },
            type: "value",
            show: false,
          },
        ],
        yAxis: [
          {
            name: this.yAxisName,
            splitLine: {
              show: false,
            },
            axisLine: {
              show: false,
            },
            type: "category",
            axisTick: {
              show: false,
            },
            inverse: true,
            data: this.chartData.days,
            axisLabel: {
              color: "#A7D6F4",
              fontSize: 12,
            },
          },
        ],
        series: [
          {
            data: this.chartData.data,
            name: "标准化",
            type: "bar",
            barWidth: 12,
            label: {
              show: true,
              position: "right",
              color: "#A7D6F4",
              fontSize: 14,
              distance: 15,
            },
            itemStyle: {
              color: new echarts.graphic.LinearGradient(
                1,
                0,
                0,
                0,
                [
                  {
                    offset: 0,
                    color: "#51C5FD",
                  },
                  {
                    offset: 1,
                    color: "#005BB1",
                  },
                ],
                false
              ),
            },
          },
        ],
      });
    },
  },
};
</script>
